import { useState } from "react";
import HighlightCardPropsType from "../../types/HighlighCardPropsType";

export default function HighlighCard({ subtitle, title, number } : HighlightCardPropsType) {
  const [active, setActive] = useState(false);
  return (
    <div
      onClick={() => setActive((prev) => !prev)}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
      className={"highlight__container" + (active ? " active" : "")}
    >
      {number ? <h3 className="highlight__title">{number} %</h3> : ""}
      <h4 className="highlight__subtitle">{title}</h4>
      <div className={"hightlight__text-container"}>
        <p className={"highlight__text"}>{subtitle}</p>
      </div>
    </div>
  );
}